/* eslint-disable max-len */
import {
    SkyDataGridColumnsState, SkyDataGridLocalStorage,
} from '../../SkyBaseDataGrid.types'

export const initFields = {
    orderedFields: [],
    dimensions: {},
}

export const defaultSetColumnsStateConverter = (value: SkyDataGridColumnsState): SkyDataGridLocalStorage => {
    return {
        columns: {
            ...value,
        },
    }
}

export const defaultInitColumnsStateConverter = (dataGridState: SkyDataGridLocalStorage) => {
    return dataGridState?.columns || initFields
}
